export enum GraphType {
  KW = 'kW',
  Amps = 'Amps',
  KWH = 'kwh',
  SoC = 'SoC',
  DETAILS = 'details'
}
